import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-folder-line"></i>
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">专题合集</h2>
          <p className="text-foreground-600 text-sm">按主题聚合爆料内容，快速找到你关心的瓜</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200 border border-transparent hover:border-secondary-200/70 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 font-heading">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-600 font-medium">{item.count} 条内容</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}